<style>
    .nc-reselect-foot{
        height: 2rem;
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 10;
        background: #fff;
        overflow: hidden;
    }
    .nc-reselect-foot .foot-btn{
        width: 100%;
        height: 2rem;
        overflow: hidden;
    }
    .nc-reselect-foot a{
        display: block;
    }
    .nc-reselect-foot p{
        text-align: center;
        height: 2rem;
        line-height: 2rem;
        font-size: 0.6rem;
        overflow: hidden;
        color: #fff;
    }
    .spec-options .spec-select {
        -webkit-overflow-scrolling: touch
    }
</style>

<template>
    <transition name="ncbottom">
        <div class="nctouch-bottom-mask mask-show" v-if="show">
            <div class="nctouch-bottom-mask-bg" @click="bindHide()" @touchmove="excludeTouch"></div>
            <div class="nctouch-bottom-mask-block">
                <div class="spec-options">
                    <div class="spec-close" @click="bindHide()"></div>
                    <div class="spec-img" >
                        <img :src="currentGoodsInfo.imageSrc|$convertImage(240,240 )" @touchmove="excludeTouch"/>
                    </div>
                    <div class="spec-menu-top" @touchmove="excludeTouch">
                        <div class="top-price">
                            <slot name="pricePanel"></slot>
                            <span v-if="showDefaultPricePanel" data-name="库存"><em>Ks{{currentGoodsPriceText}}</em><p>( အေရအတြက္：1{{currentGoodsInfo.goodsStorage}})</p></span>
                        </div>
                        <!--<div class="top-number" v-if="currentGoodsSpecString" data-name="已选">已选：{{currentGoodsSpecString}}</div>-->
                    </div>
                    <div class="spec-select" ref="scroll" @touchmove="excludeTouch">
                        <div class="prod-spec">
                            <dl class="spec" v-for="(specItem,specIndex) in specJson">
                                <dt>{{specItem.specName}}</dt>
                                <dd>
                                    <a href="javascript:;"
                                       :class="{'current':inSpecValueQueue(specIndex,specValueItem.specValueId)}"
                                       @click="bindSelectSpec(specIndex ,specValueItem.specValueId)"
                                       v-for="specValueItem in specItem.specValueList">
                                        {{specValueItem.specValueName}}
                                    </a>
                                </dd>
                            </dl>
                            <slot name="buyNumPanel"></slot>
                            <dl class="spec" v-if="showDefaultBuyNumPanel">
                                <dt data-name="数量">အေရအတြက္
                                <div class="spec-count">
                                    <a class="minus" href="javascript:;" @click.deb="bindMinusNum()"><em
                                            :class="{'no-change' : mNoChange}"></em></a>
                                    <input class="quantity" v-model.trim.number="buyNum" type="number" @blur="bindVerifyInputEmpty">
                                    <a class="add" href="javascript:;" @click.deb="bindAddNum()"><em
                                            :class="{'no-change' : aNoChange}"></em></a>
                                </div>
                            </dl>
                        </div>
                    </div>
                    <slot name="btnPanel"></slot>
                    <div class="nc-reselect-foot" v-if="showDefaultBtnPanel">
                        <div class="foot-btn-group">
                            <a :class="[canBuy ? 'green-btn' : 'grey-btn' ]" @click="bindGoodsSelect()" @touchmove.stop="excludeTouch"
                               href="javascript:;">
                                <p>{{buttonText}}</p>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>
<script>
    /**
     * 一个简单的商品sku重新选择
     */
    import BScroll from 'better-scroll'
    export default {
        name: "nc-goods-reselect",
        props: {
            show: {
                type: Boolean,
                default: false
            },
            buttonText: {
                type: String,
                default: "တြန္းလွည္းထဲထည့္ရန္"
            },
            goodsId: {
                type: Number,
                required: false
            },
            goodsCommon: {
                type: Object
            },
            // 是否验证活动已经购买限制
            isVerifyUsable:{
                type:Boolean ,
                default : true
            }
        },
        /*
         * 自身数据,一定要一个function
         */
        data() {
            return {
                //specValue 队列
                selectSpecValueQueue: [],
                // 当前的goodsId
                currentGoodsId: 0,
                oldBuyNum: 1,
                //减号不能点标识
                mNoChange: true,
                //加好不能点标识
                aNoChange: false ,
                scrollInstance: null
            }
        },
        /**
         * 计算属性
         */
        computed: {
            defaultGoodsId: function () {
                var _specJson = this.goodsCommon.specJson,
                    _goodsSpecValueJson = this.goodsCommon.goodsSpecValueJson,
                    _defaultArray = [];
                //如果没有规格就goodlist 的头一个
                if (!_specJson.length) {
                    return this.goodsCommon.goodsList[0].goodsId
                }
                _defaultArray = _specJson.map(function (value) {
                    return value.specValueList[0].specValueId
                })
                var _currentSpecJson = _goodsSpecValueJson.filter(function (value) {
                    var a = _defaultArray.slice(0),
                        b = value.specValueIds;
                    return a.sort().toString() == b.sort().toString()
                })[0];
                return _currentSpecJson.goodsId
            },
            // 当前sku信息
            currentGoodsInfo () {
                var _currentGoodsId = this.currentGoodsId ? this.currentGoodsId : this.goodsId
                if (!this.goodsCommon && !this.goodsCommon.goodsList) {
                    return null
                }
                var self = this, _goodsInfoArray = this.goodsCommon.goodsList.filter(function (item) {
                    return _currentGoodsId == item.goodsId
                })

                return _goodsInfoArray.length ? _goodsInfoArray[0] : null
            },
            // 当前价格
            currentGoodsPriceText () {
                var _g = this.currentGoodsInfo
                return getPrice0(_g);
            },
            //当前选择的规格名称字符串
            currentGoodsSpecString () {
                var _currentGoodsInfo = this.currentGoodsInfo,
                    _specArray = _currentGoodsInfo.goodsSpecString.split("；"),
                    result = []
                ;
                if (!_currentGoodsInfo.goodsSpecString) {
                    return null
                }
                _specArray.forEach(function (value) {
                    result.push("\"" + value + "\"")
                });
                return result.join("，")
            },

            specJson () {
                var s = this.goodsCommon.specJson
                return typeof s == 'string' ? JSON.parse(s) : s;
            },
            goodsSpecValueJson () {

                var g = this.goodsCommon.goodsSpecValueJson
                return typeof g == 'string' ? JSON.parse(g) : g;
            },
            goodsList () {
                return this.goodsCommon.goodsList
            },

            // 是否显示底部按钮
            showDefaultBtnPanel (){
                return this.$slots.btnPanel ? false : true
            },

            // 是否显示价格区域
            showDefaultPricePanel(){
                return this.$slots.pricePanel ? false : true
            },
            // 显示购买数量加减区域
            showDefaultBuyNumPanel(){
                return this.$slots.buyNumPanel ?false :true
            },

            /**
             * 购买数量 取值于赋值
             */
            buyNum: {
                get() {
                    return this.oldBuyNum;
                },
                set(newValue) {
                    console.log('buyNum set ')
                    var _num = parseInt(newValue),
                        //库存
                        _goodsStorage = this.isVerifyUsable &&  _isUsable && this.currentGoodsInfo.limitAmount != 0  ? this.currentGoodsInfo.limitAmount : this.currentGoodsInfo.goodsStorage ,
                        _isUsable = getUsable(this.currentGoodsInfo)
                    ;
                    //如果小于1 就直接是1
                    if (_num < 1) {
                        this.oldBuyNum = 1
                        return
                    }
                    //为最终的显示数量赋值
                    this.oldBuyNum = _num > _goodsStorage && _goodsStorage != 0  ? _goodsStorage : _num;
                    //改变加减号是否能点
                    this.mNoChange = this.oldBuyNum <= 1 ? true : false;
                    this.aNoChange = this.oldBuyNum == _goodsStorage ? true : false
                    if (this.isVerifyUsable && _isUsable && this.currentGoodsInfo.limitAmount != 0  && _num > this.currentGoodsInfo.limitAmount) {
                        alertWarn("ဤပစၥည္းအ၀ယ္ကန္႔သတ္" + this.currentGoodsInfo.limitAmount + this.goodsCommon.unitName)
                    }//此商品限购
                    this.$forceUpdate();
                    this.$emit('mod-buy-num' ,this.oldBuyNum)
                }
            },
            // 标识是否能够购买
            canBuy (){
                var _isUsable = getUsable(this.currentGoodsInfo) ,
                    goodsStorage = _isUsable && this.currentGoodsInfo.limitAmount != 0  ? this.currentGoodsInfo.limitAmount : this.currentGoodsInfo.goodsStorage
                return this.buyNum <= goodsStorage
            }
        },
        mounted(){

        },
        /**
         * 监听属性变动
         */
        watch: {
            show(newValue,oldValue) {
                this.currentGoodsId = this.goodsId ? this.goodsId : this.defaultGoodsId
                this.addSelectSpecValueQueue(this.currentGoodsId)
                if (newValue) {
                    this.$nextTick(() => {
                        if (!this.$refs.scroll) return
                        if (this.scrollInstance) {
                            this.scrollInstance.refresh()
                        } else {
                            this.scrollInstance = new BScroll(this.$refs.scroll, {
                                startX: 0,
                                startY: 0,
                                scrollX: false,
                                scrollY: true,
                                click: true,
                            });
                        }
                    })
                }
            }
        },
        /**
         * 自定义方法
         */
        methods: {
            //去除无关的touch事件
            excludeTouch(event) {
                event.preventDefault();
            },
            // 禁止事件冒泡
            excludeTouchStop(event){
                event.stopPropagation();
            },
            //判断是否在规格值队列中
            inSpecValueQueue(index, specValue) {
                return this.selectSpecValueQueue[index] == specValue
            },

            //根绝goodsid 获取规格值数组并加入队列
            addSelectSpecValueQueue(goodsId) {
                var _specValueObj = this.goodsSpecValueJson.filter(function (item) {
                    return item.goodsId == goodsId
                })[0];
                if (_specValueObj) {
                    this.selectSpecValueQueue = _specValueObj.specValueIds.slice(0);
                }

            },
            setGoodsIdForSpecJson: function () {
                var self = this
                var _specJson = this.goodsSpecValueJson.filter(function (value) {

                    var a = self.selectSpecValueQueue.slice(0),
                        b = value.specValueIds instanceof Array ? value.specValueIds : value.specValueIds.split(",");
                    return a.sort().toString() == b.sort().toString()
                })[0];
                if (!_specJson) return;
                this.currentGoodsId = _specJson.goodsId

                this.$emit('reselect-goods', this.currentGoodsInfo)
            },
            //隐藏
            bindHide() {
                //向父组建发送消息
                this.$emit('hide', this.currentGoodsInfo)
            },

            //点击规格值
            bindSelectSpec(index, specValue) {

                this.selectSpecValueQueue.splice(index, 1, specValue)
                this.setGoodsIdForSpecJson()
                this.buyNum = 1;
            },
            // 点击确定
            bindGoodsSelect() {
                var buyData = [{
                    goodsId : this.currentGoodsInfo.goodsId,
                    buyNum: this.buyNum
                }]


                this.canBuy && this.$emit('submit', buyData)
            },
            //购买数量减少
            bindMinusNum: function () {
                this.buyNum--
            },
            //购买数量增加
            bindAddNum: function () {
                this.buyNum++
            },
            // 验证num input 是否为空
            bindVerifyInputEmpty (){
                if (isNaN ( this.buyNum ) ){
                    this.buyNum = 1
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/base-components/goods-reselect/goods-reselect.vue